import { SpecialityIcon, SpecialityIconName } from '@kar-dmp/ignite';
import { EXTERNAL_LANDING_URL } from 'helpers/externalRoutes';
import { publicEnvConfig } from 'helpers/env';

const TopBarLogo = ({ navigateToLanding }) => (
	<div className="flex h-[113px] w-full items-center pl-10 max-md:h-[72px] max-md:scale-[0.63] max-md:justify-center md:justify-start">
		<a aria-label="OPENLANE home" href={navigateToLanding ? EXTERNAL_LANDING_URL : publicEnvConfig.BASE_URL}>
			<SpecialityIcon icon={SpecialityIconName.Openlane} width={276} />
		</a>
	</div>
);

export default TopBarLogo;
